import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';

import { Loader, ImageWrapper, Initials } from './elements';

type Props = {
  readonly url?: string;
  readonly size: string;
  readonly color?: string;
  readonly name: string;
  readonly isLoading?: boolean;
  readonly className?: string;
};

function PodiumImage({
  url,
  size,
  color,
  name,
  isLoading,
  className,
}: Props & ConnectedProps): React.ReactElement {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map(word => word.slice(0, 1))
    .join('');

  if (color) {
    return (
      <ImageWrapper className={className} size={size} color={color}>
        <Initials size={size}>{initials}</Initials>
      </ImageWrapper>
    );
  }

  if (isLoading) {
    return (
      <ImageWrapper size={size} className={className}>
        <Loader size={size} />
      </ImageWrapper>
    );
  }

  return <ImageWrapper className={className} size={size} url={url} />;
}

export default connect<Props>(PodiumImage);
